import logging from '@wr/logging';
import {getErrorStatusCode} from '../components/pages/PoliStatusWaiting/helpers';
import config from '../config';
import eventIds from '../event-ids';
import {throwOnResponseError} from '../utils/createResponseError';
import {getPaymentSessionId} from '../utils/helpers';

const getZepzPayinInitData = async ({
    requestId, sessionId, params, query
}) => {
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    const paymentSessionId = getPaymentSessionId(params, query);
    const loggerProps = {
        requestId, sessionId, paymentSessionId
    };

    logger.info('Retrieving Zepz Payin init data', {
        eventId: eventIds['Retrieving Zepz Payin init data'],
        ...loggerProps
    });


    try {
        const url = new URL(`/api/sessions/${paymentSessionId}/init`, config.zepzPayinIntegrator.url);

        const {origin} = new URL(config.app.url);

        const statusResponse = await fetch(url.toString(), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                origin
            })
        });

        throwOnResponseError(statusResponse);

        const statusData = await statusResponse.json();

        logger.info('Retrieved Zepz Payin init data', {
            eventId: eventIds['Retrieved Zepz Payin init data'],
            ...loggerProps,
            payload: statusData
        });

        return statusData;
    } catch (e) {
        const error = new Error(`Error retrieving Zepz Payin init data: ${e.message}`);

        error.status = getErrorStatusCode(e);

        logger.error(error.message, {
            eventId: eventIds['Error retrieving Zepz Payin init data'],
            ...loggerProps
        });

        throw error;
    }
};

export default getZepzPayinInitData;
